import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route, Redirect } from 'react-router-dom';
import type { RootState } from '../store/types';
import { TabWrapper } from './RouterOutlet.styles';
import ToastManager from '../shared/components/Toasts/ToastManager';
import { sharedSelectors } from '../shared/ducks';
import PersonalDetailsRoutes from '../tabs/PersonalDetails';
import FinancingTermsRoutes from '../tabs/FinancingTerms';
import NotificationSettingsRoutes from '../tabs/NotificationSettings';
import PrivacySettings, { PRIVACY_SETTINGS_ROUTE } from '../tabs/PrivacySettings/PrivacySettings';
import RouteWithFeatureFlag from './RouteWithFeatureFlag';
import { PERSONAL_DETAILS_PATH } from '../tabs/PersonalDetails/routes/routePaths';
import { FINANCING_TERMS_PATH } from '../tabs/FinancingTerms/routes/routePaths';
import { NOTIFICATION_SETTINGS_PATH } from '../tabs/NotificationSettings/routes/routePaths';

type StateProps = {
  isMobile: boolean;
};

function RouterOutlet({ isMobile }: StateProps) {
  const defaultPath = isMobile ? '/' : PERSONAL_DETAILS_PATH;

  return (
    <TabWrapper>
      <ToastManager />
      <Switch>
        <Route path="/" exact render={() => !isMobile && <Redirect to={PERSONAL_DETAILS_PATH} />} />
        <RouteWithFeatureFlag
          path={PERSONAL_DETAILS_PATH}
          Component={PersonalDetailsRoutes}
          featureFlag={null}
        />
        <RouteWithFeatureFlag
          path={FINANCING_TERMS_PATH}
          Component={FinancingTermsRoutes}
          featureFlag="shouldShowFinancingTermsTab"
        />
        <RouteWithFeatureFlag
          path={NOTIFICATION_SETTINGS_PATH}
          Component={NotificationSettingsRoutes}
          featureFlag="shouldShowNotificationSettingsTab"
        />
        <Route path={PRIVACY_SETTINGS_ROUTE} component={PrivacySettings} />
        <Redirect to={defaultPath} />
      </Switch>
    </TabWrapper>
  );
}

const mapStateToProps = (state: RootState) => ({
  isMobile: sharedSelectors.getIsMobile(state)
});

export default connect(mapStateToProps)(RouterOutlet);
